






import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class DocumentRegisteredNavigator extends Mixins() {
  @Prop({ default: () => [] as { label: string, process: () => void }[] })
  operations: { label: string, process: () => void }[];
}
